import { Flex, Text } from "@gravity-ui/uikit";
import { Link as RouterLink } from "react-router-dom";
import { T } from "src/i18n";

import { IKBSection } from "../../types";
import { flattenKBSections } from "../../utils";
import styles from "./KnowledgeIndex.module.scss";

interface KnowledgeIndexProps {
  basePath: string;
  tree: IKBSection[];
}

export const KnowledgeIndex = ({ basePath, tree }: KnowledgeIndexProps) => {
  const sections = flattenKBSections(tree).filter(
    (section) => (section.docs ?? []).length > 0,
  );

  return (
    <Flex direction="column" className={styles.index}>
      <Text as="h1" variant="header-2" className={styles.title}>
        <T keyName="knowledge_base.index.title" defaultValue="База знаний" />
      </Text>

      <Text as="p" variant="body-2" className={styles.subtitle}>
        <T
          keyName="knowledge_base.index.subtitle"
          defaultValue="Инструкции по работе с платформой, интеграциями и личным кабинетом."
        />
      </Text>

      {sections.map((section) => (
        <section key={section.slug} className={styles.section}>
          <Text as="h2" variant="subheader-3" className={styles.sectionName}>
            {section.name}
          </Text>

          <ul className={styles.docs}>
            {section.docs.map((doc) => (
              <li key={doc.slug} className={styles.doc}>
                <RouterLink
                  to={`${basePath}/${section.slug}/${doc.slug}`}
                  className={styles.link}
                >
                  {doc.title}
                </RouterLink>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </Flex>
  );
};
